import { useState, type ReactNode } from "react";

import { TopbarBackContext, TopbarBackSetContext, type TopbarBackLink } from "@/state/topbarBack";

/**
 * Owns the topbar's back call-to-action. Pages register one for as long as they
 * are mounted (see `useTopbarBack`); the Topbar renders it in its left slot. The
 * `useState` setter is referentially stable, so registering a link does not
 * re-render the page that registered it.
 */
export function TopbarBackProvider({ children }: { children: ReactNode }) {
  const [back, setBack] = useState<TopbarBackLink | null>(null);

  return (
    <TopbarBackSetContext.Provider value={setBack}>
      <TopbarBackContext.Provider value={back}>{children}</TopbarBackContext.Provider>
    </TopbarBackSetContext.Provider>
  );
}
